<template>
  <div id="sealrecord">
    <loading-overlay v-if="isLoading"></loading-overlay>
    <div class="search">
      <el-form ref="dialogfref" :model="dialogform" label-width="96px">
        <el-row>
          <el-col :span="5">
            <el-form-item label="申请人" prop="ApplicantName">
              <el-input
                clearable
                v-model="dialogform.ApplicantName"
                placeholder="请输入申请人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="录入人" prop="PostName">
              <el-input
                clearable
                v-model="dialogform.PostName"
                placeholder="请输入录入人"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item label="申请时间">
              <el-date-picker
                class="select"
                v-model="dialogform.StartTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="申请时间">
              <el-date-picker
                class="select"
                v-model="dialogform.EndTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="用章类型" prop="SealType">
              <el-select
                clearable
                v-model="dialogform.SealType"
                placeholder="请选择"
                class="select"
              >
                <el-option
                  v-for="item in seal"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="用章申请状态" prop="Status">
              <el-select v-model="dialogform.Status" placeholder="请选择">
                <el-option
                  clearable
                  v-for="item in Status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label-width="0">
              <div class="btn">
                <el-button type="primary" @click="searchseal()">搜索</el-button>
                <el-button @click="reset('dialogfref')">重置</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="main">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="applicantName" label="申请人姓名">
        </el-table-column>
        <el-table-column prop="reason" label="申请事由"> </el-table-column>
        <el-table-column prop="sealType" label="用章类型" width="140">
          <template slot-scope="scope">
            <span>{{ getSealLabels(scope.row.sealType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="postTime" label="申请时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.postTime) }}
          </template>
        </el-table-column>
        <!-- <el-table-column
              prop="sealtime"
              label="用印时间">
            </el-table-column> -->
        <el-table-column label="当前状态" prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" type="text" class="spz"
              >审批中</span
            >
            <span
              v-if="scope.row.result == 1 && scope.row.status == 0"
              type="text"
              class="fail"
              >被驳回</span
            >
            <span
              v-if="scope.row.result == 0 && scope.row.status == 0"
              type="text"
              class="pass"
              >通过</span
            >
            <!-- <span v-if="scope.row.status==-1" type="text" class="del">已撤回</span> -->
            <span v-if="scope.row.status == -1" type="text" class="del"
              >已撤销</span
            >
            <!-- <span v-if="scope.row.status==2" type="text" class="del">已取消</span> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="160">
          <template slot-scope="scope">
            <!-- <el-button class="tg" size="small" @click="approval(scope.row.id,0)">通过</el-button>
                <el-button class="bh" size="small" @click="approval(scope.row.id,1)">驳回</el-button> -->
            <el-button
              class="look"
              size="small"
              @click="Look(scope.row.id)"
              v-if="$store.state.rolesname.includes('Sealdetail')"
              >查看</el-button
            >
            <el-button
              v-if="
                scope.row.result == -1 &&
                scope.row.status == 1 &&
                $store.state.rolesname.includes('sealrecord_del')
              "
              class="delbtn"
              size="small"
              @click="del(scope.row.id, 4)"
              >撤销</el-button
            >

            <el-popconfirm
              style="margin: 0 5% 0 5%"
              title="是否确定删除该条数据？"
              @confirm="jqsClick(scope.row.id)"
              v-if="
                scope.row.status == 0 &&
                scope.row.status != -1 &&
                $store.state.rolesname.includes('sealrecord_delete')
              "
            >
              <el-button type="warning" size="small" slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <div class="bank_pagination">
        <el-pagination
          :hide-on-single-page="value"
          :current-page.sync="PageIndex"
          :page-sizes="PageSizes"
          :page-size="PageSize"
          :pager-count="MaxPage"
          layout="total, sizes, prev, pager, next"
          :total="Total"
          v-if="bPageShow"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!--更多选择!-->
    <el-dialog
      title="搜索"
      :visible.sync="dialogVisible"
      width="45%"
      center
      :show-close="false"
    >
      <el-form ref="dialogfref" :model="dialogform" label-width="96px">
        <el-form-item label="申请人" prop="ApplicantName">
          <el-input
            v-model="dialogform.ApplicantName"
            placeholder="请输入要查找的申请人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="录入人" prop="PostName">
          <el-input
            v-model="dialogform.PostName"
            placeholder="请输入要查找的录入人姓名"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请时间">
              <el-date-picker
                style="width: 100%"
                v-model="dialogform.StartTime"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-date-picker
                style="width: 100%"
                v-model="dialogform.EndTime"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="用章类型" prop="SealType">
          <el-select v-model="dialogform.SealType" placeholder="请选择用章类型">
            <el-option
              v-for="item in seal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章申请状态" prop="Status">
          <el-select
            v-model="dialogform.Status"
            placeholder="请选择用章申请状态"
          >
            <el-option
              v-for="item in Status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="0">
          <div class="btn">
            <el-button type="primary" @click="searchseal()">搜索</el-button>
            <el-button @click="reset('dialogfref')">重置</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
  
<script>
import { Seal, SealDel, SealDelete } from '../../api/seal'
export default {
  name: 'sealrecord',
  data() {
    return {
      bPageShow: true,
      // next: true,//是否是三级菜单,
      next: false, //是否是三级菜单
      Con: '',
      more: '',
      isLoading: false,
      dialogVisible: false,
      form: {
        name: '',
        status: '',
        starttime: '',
        endtime: '',
        type: '破产案件',
        invoice: 0,
        closecase: 0,
        file: 0
      },
      dialogform: {
        ApplicantName: '',
        PostName: '',
        SealType: '',
        Status: null,
        StartTime: null,
        EndTime: null
      },
      Status: [
        { label: '已通过', value: 0 },
        { label: '待审核', value: 1 },
        { label: '被驳回', value: 2 },
        { label: '已撤销', value: 4 }
      ],
      // { label: "已删除", value: -1 }],

      dialogVisible: false, //弹出框
      // IsorNo:[{ label: "是", value: 0 }, { label: "否", value: 1 }],
      // Casetype:[{ label: "民事案件", value: "民事案件" }, { label: "破产案件", value: "破产案件" }],
      seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' },
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ], //合同用章
      tableData: [],
      PageSizes: [5, 10, 20, 50],
      PageIndex: 1,
      PageSize: 10,
      Total: 0,
      MaxPage: 5,
      value: false //只有一页的时候隐藏分页
    }
  },

  methods: {
    // 删除
    jqsClick(id) {
      SealDelete({ Id: id }).then((res) => {
        if (res.data.status == 'success') {
          this.$message.success('删除成功')
          this.search()
        } else {
          this.$message.success(res.data.message)
        }
      })
    },
    getSealLabels(sealType) {
      return sealType
        .map((type) => {
          const seal = this.seal.find((s) => s.value === type)
          return seal ? seal.label : type
        })
        .join(', ')
    },
    del(id, status) {
      this.$confirm('此操作将撤回申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.isLoading = true
          SealDel({ Id: id, Status: status }).then((res) => {
            if (res.data.status == 'success') {
              this.$message({
                type: 'success',
                message: '撤回成功!'
              })
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
            this.isLoading = false
            this.search()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤销'
          })
        })
    },
    Look(id) {
      //查看
      this.$router.push({
        name: 'Sealdetail',
        path: '/home/seal/Sealdetail',
        query: {
          guid: id
        }
        // params: {//筛选条件传过去
        //   PageIndex:this.PageIndex,
        //   PageSize:this.PageSize,
        //   dialogform:this.dialogform,
        // }
      })
    },
    moreSelect() {
      //更多选择
      this.$refs.choose.blur()
      this.dialogVisible = true
    },

    handleSizeChange(val) {
      this.PageSize = val
      this.search()
      // console.log(`每页 ${val} 条`);
      // if(Math.ceil(this.Total/val)<=1){
      //     this.value=true;
      // }
    },
    handleCurrentChange(val) {
      this.PageIndex = val
      this.search()
    },
    searchseal() {
      //搜索按钮
      this.PageIndex = 1
      this.search()
    },
    search() {
      //获取数据
      this.isLoading = true
      var starttime = null
      var endtime = null
      if (this.dialogform.StartTime) {
        starttime = this.JsonTime(this.dialogform.StartTime)
      }
      if (this.dialogform.EndTime) {
        endtime = this.JsonTime(this.dialogform.EndTime)
      }
      Seal({
        page: this.PageIndex,
        rows: this.PageSize,
        SealType: this.dialogform.SealType,
        ApplicantName: this.dialogform.ApplicantName,
        PostName: this.dialogform.PostName,
        Status: this.dialogform.Status,
        StartTime: starttime,
        EndTime: endtime
      }).then((res) => {
        if (res.data.status == 'success') {
          this.tableData = res.data.data
          this.Total = res.data.total
          this.dialogVisible = false
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
        this.isLoading = false
      })
    },
    reset(form) {
      //重置更多选择
      this.dialogform.SealType = ''
      this.dialogform.ApplicantName = ''
      this.dialogform.PostName = ''
      this.dialogform.StartTime = null
      this.dialogform.EndTime = null
      this.dialogform.Status = null
      this.search()
    },
    // change(){
    //   this.dialogform.ApplicantName=""
    // },
    getvalue() {
      //传值给父组件，
      //判断有没有审核权限，有的话该页面是三级页面，没有为二级页面
      let target = this.$store.state.permission.addRoutes.filter(
        (el) => el.path == '/home/seal' //遍历每一个数组，过滤出返回值委true的值
      )
      var arr = target[0].children.filter(
        //查询审核权限
        (el) => el.path == 'SealApprove'
      )
      if (arr.length <= 0) {
        //没有用章审核权限
        this.next = false //该页面不为三级页面
      }
      // if(target[0].children[0].path!='SealApprove'){//没有用章审核权限
      //   this.next = false;//该页面不为三级页面
      // }
      this.$emit('value', this.next)
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    // --时间格式转换--
    formatTime(row) {
      const date = new Date(row)
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      if (hours == '00' && minutes == '00' && seconds == '00') {
        return year + '-' + month + '-' + day
      } else {
        return (
          year + '-' + month + '-' + day
          // +
          // ' ' +
          // hours +
          // ':' +
          // minutes +
          // ':' +
          // seconds
        )
      }
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    }
  },
  created() {
    this.getvalue()
    // if(this.$route.params.dialogform){//有值的话就是从详情页过来的
    //   this.PageSize = this.$route.params.PageSize //获取进入详情页前的筛选条件
    //   this.PageIndex = this.$route.params.PageIndex
    //   this.dialogform = this.$route.params.dialogform
    // }
    // this.search();
    // console.log(this.$route.params.dialogform)
  },
  beforeRouteLeave(to, from, next) {
    const type = 'sealrecordPage'
    if (to.name == 'Sealdetail') {
      var con = {
        form: this.dialogform,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize
      }
      this.$store.dispatch('saveSearchCondition', { type, condition: con }) //保存
    } else {
      this.$store.dispatch('clearSearchConditions', type) //保存
    }

    next()
  },
  beforeRouteEnter(to, from, next) {
    // 辅助函数，用于在组件实例化之前执行一些代码
    function fetchData() {
      const type = 'sealrecordPage'
      // console.log("获取")
      // 从 Vuex store 中读取搜索条件
      if (this.$store.state.searchConditions[type]) {
        return this.$store.state.searchConditions[type]
      }
      return null
    }
    // 通过 next 回调访问组件实例
    next((vm) => {
      const fetchedData = fetchData.call(vm)
      if (fetchedData && from.name == 'Sealdetail') {
        vm.dialogform = fetchedData.form
        vm.PageIndex = fetchedData.PageIndex
        vm.PageSize = fetchedData.PageSize
        // console.log(fetchedData.PageIndex)
        vm.bPageShow = false
        vm.$nextTick(() => {
          vm.bPageShow = true
        })
        vm.search()
      } else {
        vm.search()
      }
    })
  }
}
</script>
  
<style lang="less" scoped>
// 查询
#sealrecord .search {
  box-sizing: border-box;
  width: 100%;
  // margin: auto;
  // display: flex;

  padding: 20px;
  // margin-bottom: 24px;
}

#sealrecord .search ::v-deep .el-input__inner {
  // width: 80% !important;
  // width: 300px;
  background-color: #fafafa;
  border: 0 !important;
  border-radius: 12px;
}

#sealrecord .nameSearch {
  width: 24vw;
  margin-right: 10px;
}

// #sealrecord .select {
//   width: 10vw;
//   margin-right: 10px;
// }

// 弹出框
#sealrecord /deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

.btn {
  width: 100%;
  text-align: center;
}

//表格
#sealrecord .casestatus {
  color: rgba(254, 150, 74, 1);
}

#sealrecord .pass {
  color: #3077e6;
}

#sealrecord .spz {
  color: #0caf60;
}

#sealrecord .fail {
  color: #fe964a;
}

#sealrecord .del {
  color: red;
}

#sealrecord .look {
  background: #eff5ff;
  border-radius: 8px;
  color: #3077e6;
  border: none;
}

#sealrecord .delbtn {
  background: #fff0e6;
  border-radius: 8px;
  color: #fe964a;
  border: none;
}

// 分页
#sealrecord .bank_pagination {
  text-align: right;
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

#sealrecord /deep/.el-pagination__total {
  float: left;
}

/deep/.el-pagination__sizes {
  float: left;
}
</style>
  